import React from 'react';
import { Link } from 'react-router-dom';
import { diseases } from '../mockData';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { ChevronRight } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';

const ConditionsPage = () => {
  return (
    <>
      <Header />
      <main className="pt-24 pb-16 bg-white dark:bg-slate-900">
        {/* Hero Section */}
        <section className="bg-gradient-to-r from-blue-600 to-blue-700 py-16">
          <div className="max-w-7xl mx-auto px-6 text-center">
            <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Conditions We Treat
            </h1>
            <p className="text-xl text-blue-100 max-w-2xl mx-auto">
              Comprehensive diagnosis and treatment for all respiratory and lung conditions
            </p>
          </div>
        </section>

        <section className="max-w-7xl mx-auto px-6 py-12">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {diseases.map((disease) => (
              <Card key={disease.id} className="hover:shadow-lg transition-shadow overflow-hidden">
                <div className="h-48 overflow-hidden">
                  <img src={disease.image} alt={disease.title} className="w-full h-full object-cover" />
                </div>
                <CardContent className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 dark:text-slate-50 mb-2">{disease.title}</h3>
                  <p className="text-gray-600 dark:text-slate-400 mb-4 line-clamp-2">{disease.shortDesc}</p>
                  <Link to={`/conditions/${disease.id}`}>
                    <Button variant="outline" className="w-full group">
                      Learn More
                      <ChevronRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                    </Button>
                  </Link>
                </CardContent>
              </Card>
            ))}
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppButton />
    </>
  );
};

export default ConditionsPage;
